import CaseManagement from '@/vuepage/case/index';
import MannerList from '../vuepage/case/manner-list';
import CaseList from '../vuepage/case/list';
import CaseAdd from '../vuepage/case/case-add';
import CaseEditUser from '../vuepage/case/case-edit-user';
import AuditList from '../vuepage/case/audit-list';
import CaseBanner from '../vuepage/case/case-banner';
import BannerAdd from '../vuepage/case/banner-add';
import Detail from '../vuepage/case/detail';

export default [
  {
    path: '/case-management',
    component: CaseManagement,
    children: [
      {
        path: 'manner-list',
        component: MannerList,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '风格列表',
            url: 'manner-list',
          },
        ],
      },
      {
        path: 'list',
        component: CaseList,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '案例列表',
            url: 'list',
          },
        ],
      },
      {
        path: 'case-add',
        component: CaseAdd,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '案例列表',
            url: 'list',
          },
          {
            name: '新增/编辑案例',
            url: 'case-add',
          },
        ],
      },
      {
        path: 'case-edit-user',
        component: CaseEditUser,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '案例列表',
            url: 'list',
          },
          {
            name: '编辑案例',
            url: 'case-edit-user',
          },
        ],
      },
      {
        path: 'audit-list',
        component: AuditList,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '审核列表',
            url: 'audit-list',
          },
        ],
      },
      {
        path: 'detail',
        component: Detail,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '案例列表',
            url: 'audit-list',
          },
          {
            name: '案例详情',
            url: 'detail',
          },
        ],
      },
      {
        path: 'case-banner',
        component: CaseBanner,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '案例轮播图',
            url: 'case-banner',
          },
        ],
      },
      {
        path: 'banner-add',
        component: BannerAdd,
        meta: [
          {
            name: '案例管理',
            url: '/case-management',
          },
          {
            name: '案例轮播图',
            url: 'case-banner',
          },
          {
            name: '新增/编辑轮播图',
            url: 'banner-add',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/case.js